import { ChartData } from 'chart.js';
import { GenericChart } from 'app/agriculture/charts/GenericChart/GenericChart';
import { Bar } from 'react-chartjs-2';
import './SkeletonBarChart.scss';
import classNames from 'classnames';
import { Skeleton } from '@mui/material';
import { getDefaultBarChartOptions } from '../BarChart/DefaultBarChartOptions';

const blackOpacityColor = 'rgba(0, 0, 0, 0.2)';

export function SkeletonBarChart({ title }: { title?: string }) {
    const data = [95, 100, 80, 81, 82, 60, 50, 40, 30, 40, 35];

    const chartData: ChartData<'bar'> = {
        labels: Array.from({ length: data.length }, (_, i) => i + 1),
        datasets: [
            {
                data,
                pointStyle: 'circle',
                borderColor: blackOpacityColor,
                backgroundColor: blackOpacityColor,
            },
        ],
    };

    const chartOptions = getDefaultBarChartOptions({});
    chartOptions.plugins = chartOptions.plugins ?? {};
    chartOptions.plugins.tooltip = { enabled: false };
    if (chartOptions.scales?.y?.ticks?.color != null) {
        chartOptions.scales.y.ticks.color = blackOpacityColor;
    }
    if (chartOptions.scales?.x != null) {
        chartOptions.scales.x = {
            display: false,
        };
    }

    return (
        <GenericChart title={title} currentValue={<Skeleton width={20} />}>
            <span className={classNames('SkeletonBarChart__title')}>Loading</span>
            <Bar
                className={classNames('SkeletonBarChart--loading')}
                data={chartData}
                options={chartOptions}
            />
        </GenericChart>
    );
}
